import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { signUp, login } from '../../../store/actions/authActions';
import {
  validateEmail,
  validatePasswordLength,
  checkForPassMatch,
} from '../../../utils/reusables/auth';
import * as actionTypes from '../../../store/actions/allActionList';

import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import StyledTabs from './StyledTabs';
import SignIn from './SignIn';
import SignUp from './SignUp';
import { FixedWrapper } from './AuthWrappers';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const TransitionsModal = ({
  history,
  lang,
  open,
  tabValue,
  onUnsetLoginModalState,
  onClientSetSignInError,
  onClientSetSignUpError,
  onSignUp,
  onLogin,
  signInError,
  signUpError,
}) => {
  const classes = useStyles('');
  const dynamicAuthCmp =
    tabValue === 0 ? (
      <SignIn
        login={(e, p) => {
          const emailChecker = validateEmail(e);
          const passwordLengthChecker = validatePasswordLength(p);

          if (emailChecker === 'pass') {
            if (passwordLengthChecker === 'pass') {
              onLogin(e, p);
              onUnsetLoginModalState();
            } else {
              onClientSetSignInError(passwordLengthChecker);
            }
          } else {
            onClientSetSignInError(emailChecker);
          }
        }}
        resetPassword={() => {
          onUnsetLoginModalState();
          history.push('/reset/password');
        }}
        error={signInError}
      />
    ) : (
      <SignUp
        lang={lang}
        onCloseModal={() => onUnsetLoginModalState()}
        passSignUpCall={(e, p, cp, confirm) => {
          const emailChecker = validateEmail(e);
          const passwordMatchChecker = checkForPassMatch(p, cp);
          const passwordLengthChecker = validatePasswordLength(p, cp);

          if (emailChecker === 'pass') {
            if (passwordMatchChecker === 'pass') {
              if (passwordLengthChecker === 'pass') {
                if (confirm) {
                  onSignUp(e, p, cp, lang);
                  onUnsetLoginModalState();
                } else {
                  onClientSetSignUpError('sign-up.confirmation-needed');
                }
              } else {
                onClientSetSignUpError(passwordLengthChecker);
              }
            } else {
              onClientSetSignUpError(passwordMatchChecker);
            }
          } else {
            onClientSetSignUpError(emailChecker);
          }
        }}
        error={signUpError}
      />
    );

  return (
    <Modal
      aria-labelledby='transition-modal-title'
      aria-describedby='transition-modal-description'
      className={classes.modal}
      open={open}
      onClose={onUnsetLoginModalState}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade style={{ outline: 'none' }} in={open}>
        <FixedWrapper>
          <StyledTabs />
          {dynamicAuthCmp}
        </FixedWrapper>
      </Fade>
    </Modal>
  );
};

const mapStateToProps = ({ locale, modals, user }) => ({
  lang: locale.langLocale,
  open: modals.showLoginModal,
  tabValue: modals.authTabValue,
  signInError: user.signInError,
  signUpError: user.signUpError,
});

const mapDispatchToProps = (dispatch) => ({
  onUnsetLoginModalState: () => {
    dispatch({ type: actionTypes.UNSET_LOGIN_MODAL_STATE });
    dispatch({ type: actionTypes.RESET_AUTH_ERRORS });
  },
  onClientSetSignInError: (message) =>
    dispatch({ type: actionTypes.CLIENT_SET_SIGN_IN_ERROR, message }),
  onClientSetSignUpError: (message) =>
    dispatch({ type: actionTypes.CLIENT_SET_SIGN_UP_ERROR, message }),
  onSignUp: (email, password, confirmPassword, lang) =>
    dispatch(signUp(email, password, confirmPassword, lang)),
  onLogin: (email, password) => dispatch(login(email, password)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TransitionsModal));
